import moment from "moment";
import RenderButtonForCalendar from "../../Home/RenderButtonForCalender";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { SessionKeys, clickStreamUser } from "../../../utils/AppUtils";
import {
  boardcastDataResponse,
  cancelSessionDataClear,
  getEnrollBrokerSession,
  getEnrollBrokerSessionClear,
  hostSession,
  hostSessionClear,
  joinSession,
  joinSessionClear,
  sessionWatchURLDataResponse,
} from "../../../redux/events/actions";
import { homePageMsg, homePageShowMsg } from "../../../redux/home/actions";
import { addToCartClear } from "../../../redux/product/actions";
import _ from "lodash";
import { useTranslation } from "react-i18next";

const LiveMenuButton = ({ eventData, dispatchAPILiveCall }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const authBroker = useSelector((state) => state.auth.authBroker);
  const userRole = useSelector((state) => state.user.role);
  const activeLanguage = useSelector((state) => state.home.activeLanguage);
  const joinSessionData = useSelector((state) => state.events.joinSession);
  const addToCartRes = useSelector((state) => state.product.addToCart);
  const hostSessionInfo = useSelector((state) => state.events.hostSession);
  const enrollBrokerSession = useSelector(
    (state) => state.events.enrollBrokerSession
  );
  const attendence = useSelector(
    (state) => state.events.sessionAttendenceMarked
  );
  const sessionCancelledData = useSelector(
    (state) => state.events.sessionCancel
  );
  const showHomePageMsg = useSelector((state) => state.home.showHomePageMsg);

  const [showLoaderLive, setShowLoaderLive] = useState(false);

  useEffect(() => {
    setShowLoaderLive(!showHomePageMsg);
  }, [showHomePageMsg]);

  useEffect(() => {
    if (!_.isEmpty(hostSessionInfo)) {
      if (hostSessionInfo.status === "success") {
        if (!_.isEmpty(hostSessionInfo.payload.payload)) {
          // console.log('hostSessionInfo', hostSessionInfo.payload.payload);
          // const hostData = hostSessionInfo.payload.payload.data;
          setShowLoaderLive(false);
          // if (hostData.start_url) {
          //     window.open(hostData.start_url, '_blank');
          //     // dispatchAPILiveCall();
          // } else {
          //     if (userRole === 'realtor') {
          //         dispatch(homePageMsg('Server Error, please contact your manager'))
          //     } else if (userRole === 'manager') {
          //         dispatch(homePageMsg('Server Error, please contact your admin'))
          //     } else {
          //         dispatch(homePageMsg('Server Error, please contact support'))
          //     }
          // }
        } else {
          // console.log(hostSessionInfo.error.message)
          // dispatch(homePageMsg(hostSessionInfo.error.message))
        }
      } else {
        // dispatch(homePageMsg(hostSessionInfo.error.message))
      }
      // dispatch(homePageShowMsg(true))
      setShowLoaderLive(false);
      // setTimeout(() => {
      //     dispatch(homePageShowMsg(false))
      // }, 5000)
      // dispatch(hostSessionClear())
    }
  }, [hostSessionInfo]);

  useEffect(() => {
    // console.log('joinSessionData', joinSessionData);
    if (!_.isEmpty(joinSessionData)) {
      if (joinSessionData.status === "success") {
        if (!_.isEmpty(joinSessionData.payload.payload)) {
          // const sessionData = joinSessionData.payload.payload;
          setShowLoaderLive(false);
          // if (sessionData.join_url) {
          //     window.open(sessionData.join_url, '_blank');
          // } else {
          //     if (userRole === 'realtor') {
          //         dispatch(homePageMsg('Error joining session, please contact your manager'))
          //     } else if (userRole === 'manager') {
          //         dispatch(homePageMsg('Error joining session, please contact your admin'))
          //     } else {
          //         dispatch(homePageMsg('Error joining session, please contact support'))
          //     }
          // }
        } else {
          // dispatch(homePageMsg(joinSessionData.error.message))
        }
      } else {
        // console.log(joinSessionData.error.message)
        // dispatch(homePageMsg(joinSessionData.error.message))
      }
      // dispatch(homePageShowMsg(true))
      setShowLoaderLive(false);
      // setTimeout(() => {
      //     dispatch(homePageShowMsg(false))
      // }, 5000)
      // dispatch(joinSessionClear())
    }
  }, [joinSessionData]);

  useEffect(() => {
    if (!_.isEmpty(enrollBrokerSession)) {
      if (enrollBrokerSession?.status === "success") {
        // console.log("enrolled FROM live button", enrollBrokerSession);
        // let data = enrollBrokerSession.payload.payload;
        // dispatch(homePageMsg(enrollBrokerSession.payload.message))
        // clickStreamUser("session-registered-successfull", {
        //     // event_id: event_id,
        //     session_id: data.session_id,
        //     user_id: authBroker?.payload?.user?.user_id,
        //     message: enrollBrokerSession.payload.message,
        // });
        dispatchAPILiveCall();
        // console.trace('Refresh Calendar Data')
      } else if (enrollBrokerSession?.status === "error") {
        // dispatch(homePageMsg(enrollBrokerSession.error.message))
      }
      // dispatch(homePageShowMsg(true))
      setShowLoaderLive(false);
      // setTimeout(() => {
      //     dispatch(homePageShowMsg(false))
      // }, 5000)
      // dispatch(getEnrollBrokerSessionClear());
    }
  }, [enrollBrokerSession]);

  useEffect(() => {
    // setShowModalMsg(addToCartRes?.payload.message)
    if (Object.keys(addToCartRes).length !== 0) {
      // navigate('/cart')
      // dispatch(addToCartClear())
    }
  }, [addToCartRes]);

  const watchSession = (session) => {
    // dispatch(homePageShowMsg(true))
    // dispatch(homePageMsg('You are registered for the Session.'))
    dispatch(
      sessionWatchURLDataResponse({
        id: session.sessionId,
        title: session.title,
        watch_url: session.watch_url,
      })
    );
    navigate("/session/watch");
  };

  // const cancelSessionConfirmation = (session) => {
  //     setConfirmModal(true)
  //     setSessionDataForModal(session)
  //     setShowLoaderLive(true)
  // }

  const showBoardcastLive = (session) => {
    // console.log('boardcast', session)
    dispatch(boardcastDataResponse(session));
    navigate("/session/broadcast/watch");
  };

  const launchSessionLive = (session) => {
    clickStreamUser("launch-session", {
      event_id: session.eventId,
      session_id: session.sessionId,
      session_name: session.session_name,
      user_id: authBroker?.payload?.user?.user_id,
    });
    if (session.is_boardcast) {
      showBoardcastLive(session);
    } else {
      if (session.join_url) {
        window.open(session.join_url, "_blank");
      } else {
        dispatch(
          joinSession({
            module: "joinZoomMeeting",
            postData: {
              user_id: authBroker?.payload?.user?.user_id,
              meeting_id: session.meetingId,
              session_id: session.sessionId,
              segment_id: session.segmentId,
            },
          })
        );
        // if (session.meetingId) {
        // } else {
        //     dispatch(homePageMsg('Host has not yet started the meeting.'))
        //     dispatch(homePageShowMsg(true))
        //     setShowLoaderLive(false)
        //     setTimeout(() => {
        //         dispatch(homePageShowMsg(false))
        //     }, 5000)
        // }
      }
    }
  };

  const hostSessionData = (session) => {
    // console.log({
    //   user_id: session.userId,
    //   host_zoom_id: session.hostZoomId,
    //   meeting_topic: session.title,
    //   meeting_agaenda: session.title,
    //   meeting_startdate: moment(session.start).format("YYYY-MM-DD HH:mm"),
    //   duration: _.toNumber(session.durationValue),
    //   session_id: session.sessionId,
    //   segment_id: session.segmentId
    // })
    // return;
    if (session.start_url) {
      window.open(session.start_url, "_blank");
      setShowLoaderLive(false);
    } else {
      dispatch(
        hostSession({
          module: "createZoomMeeting",
          postData: {
            user_id: session.userId,
            host_zoom_id: session.hostZoomId,
            meeting_topic: session.title,
            meeting_agaenda: session.title,
            meeting_startdate: moment
              .utc(session.startUTC)
              .format("YYYY-MM-DD HH:mm"),
            duration: _.toNumber(session.durationValue),
            session_id: session.sessionId,
            segment_id: session.segmentId,
          },
        })
      );
    }
  };

  const proceedToRegisterLive = (session) => {
    // console.log("session", session);
    clickStreamUser("register-button-clicked", {
      event_id: session.eventId,
      session_id: session.sessionId,
      session_name: session.title,
      user_id: authBroker?.payload?.user?.user_id,
      type: session.source,
    });
    dispatch(
      getEnrollBrokerSession({
        module: "enrollBrokerSession",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          session_id: session.sessionId,
          event_id: session.eventId,
          type: session.source,
          language: activeLanguage ? activeLanguage : "",
        },
      })
    );
  };

  const proceedToBookLive = (session) => {
    clickStreamUser("proceed-to-book-session", {
      event_id: session.eventId,
      session_id: session.sessionId,
      session_name: session.title,
      user_id: authBroker?.payload?.user?.user_id,
    });
    navigate(
      `/shopping/${session.productId}?addToCart=${session.is_addToCart}&source=session`
    );
    // dispatch(addToCart({
    //   module: 'addToCart',
    //   postData: {
    //     "pid": session.productId,
    //     "email": userDetails?.email ? userDetails?.email : localStorage.getItem(SessionKeys.EMAIL_ID),
    //     "first_name": userDetails?.firstname,
    //     "last_name": userDetails?.lastname,
    //     "username": userDetails?.username,
    //     "company": "",
    //     "address_1": "",
    //     "address_2": "",
    //     "city": "",
    //     "state": "",
    //     "postcode": "",
    //     "country": "",
    //     "phone": "",
    //     "isPremium": isPremiumUser,
    //     "broker_id": userDetails?.broker_id,
    //     "company_id": userDetails?.company_id,
    //   }
    // }))
  };

  const redirectToEvent = (eventDetail) => {
    console.log("redirect to event", eventDetail.isCertify);
    if (
      eventDetail.userRole === "realtor" ||
      eventDetail.userRole === "manager"
    ) {
      if (eventDetail.source === "broker") {
        navigate(
          `/event-detail?event_id=${eventDetail.eventId}&event_code=&source=broker`
        );
      } else {
        if (eventDetail.isCertify) {
          navigate(
            `/certify-detail?certify_id=${eventDetail.eventId}&certify_code=${eventDetail.eventCode}&source=xsel#`
          );
        } else {
          navigate(
            `/event-detail?event_id=${eventDetail.eventId}&event_code=${eventDetail.eventCode}&source=ecom`
          );
        }
      }
    }
  };

  const renderButton = (eventDetail) => {
    // console.log('Event Detail', eventDetail)
    if (!_.isEmpty(eventDetail)) {
      if (eventDetail.delivery_mode !== "face_to_face") {
        if (eventDetail.source === "broker") {
          if (eventDetail.is_registered && eventDetail.is_participant) {
            if (eventDetail.delivery_mode !== "face_to_face") {
              const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
              const startTime = moment(`${eventDetail.start}`).subtract(
                1,
                "hour"
              );
              const endTime = moment(`${eventDetail.end}`);
              const currentTime = moment(eventDetail.current_time); //moment().utcOffset(eventDetail.tz);
              // console.log('meetingId', eventDetail.meetingId)
              if (currentTime.isBetween(startTime, endTime)) {
                return (
                  <>
                    <RenderButtonForCalendar
                      isActive={true}
                      title="Join"
                      isLoaded={showLoaderLive}
                      eventData={eventDetail}
                      onClick={(eventDetail) =>
                        eventDetail.is_boardcast
                          ? showBoardcastLive(eventDetail)
                          : launchSessionLive(eventDetail)
                      }
                      isLiveButton={true}
                    />
                  </>
                );
              }
            }
          } else if (eventDetail.is_host) {
            if (eventDetail.delivery_mode !== "face_to_face") {
              const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
              const startTime = moment(`${eventDetail.start}`)
                .tz(systemTz)
                .subtract(1, "hour");
              const endTime = moment(`${eventDetail.end}`).tz(systemTz);
              const currentTime = moment(eventDetail.current_time); //moment().utcOffset(eventDetail.tz);
              // console.log('meetingId', eventDetail.meetingId)
              if (currentTime.isBetween(startTime, endTime)) {
                return (
                  <>
                    {/* <button className={'btn-join active'}
                          onClick={() => hostSessionData(eventDetail)}>
                            Host
                          </button> */}
                    <RenderButtonForCalendar
                      isActive={true}
                      title="Host"
                      isLoaded={showLoaderLive}
                      eventData={eventDetail}
                      onClick={(eventDetail) =>
                        eventDetail.is_boardcast
                          ? showBoardcastLive(eventDetail)
                          : hostSessionData(eventDetail)
                      }
                      isLiveButton={true}
                    />
                  </>
                );
              }
            }
          } else {
            if (eventDetail.tense === "past") {
              return <>{/* Session has ended. */}</>;
            } else {
              if (userRole === "host" || userRole === "instructor") {
                if (eventDetail.delivery_mode === "face_to_face") {
                  <RenderButtonForCalendar
                    isActive={true}
                    title={t("View")}
                    isLoaded={showLoaderLive}
                    eventData={eventDetail}
                    onClick={() => {}}
                    isLiveButton={true}
                  />;
                } else {
                  <RenderButtonForCalendar
                    isActive={true}
                    title="Join"
                    isLoaded={showLoaderLive}
                    eventData={eventDetail}
                    onClick={(eventDetail) =>
                      eventDetail.is_boardcast
                        ? showBoardcastLive(eventDetail)
                        : launchSessionLive(eventDetail)
                    }
                    isLiveButton={true}
                  />;
                }
              } else {
                if (eventDetail.showRegister || eventDetail.beforeEndTime) {
                  return (
                    <>
                      <RenderButtonForCalendar
                        isActive={true}
                        title="Register"
                        isLoaded={showLoaderLive}
                        eventData={eventDetail}
                        onClick={(eventDetail) =>
                          proceedToRegisterLive(eventDetail)
                        }
                        isLiveButton={true}
                      />
                    </>
                  );
                } else {
                  return <>Show Register Button</>;
                }
              }
            }
            // console.log('EVENT CLICKED NOT PAID', eventDetail.title)
          }
        } else {
          if (eventDetail.is_registered && eventDetail.is_participant) {
            // console.log('eventDetail', eventDetail)
            if (eventDetail.delivery_mode !== "face_to_face") {
              const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
              const startTime = moment(`${eventDetail.start}`).subtract(
                1,
                "hour"
              );
              const endTime = moment(`${eventDetail.end}`);
              const currentTime = moment(eventDetail.current_time); //moment().utcOffset(eventDetail.tz);
              // console.log('meetingId', eventDetail.meetingId)
              if (currentTime.isBetween(startTime, endTime)) {
                return (
                  <>
                    <RenderButtonForCalendar
                      isActive={true}
                      title="Join"
                      isLoaded={showLoaderLive}
                      eventData={eventDetail}
                      onClick={(eventDetail) =>
                        eventDetail.is_boardcast
                          ? showBoardcastLive(eventDetail)
                          : launchSessionLive(eventDetail)
                      }
                      isLiveButton={true}
                    />
                  </>
                );
              }
            }
          } else if (eventDetail.is_host) {
            if (eventDetail.delivery_mode !== "face_to_face") {
              const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
              const startTime = moment(`${eventDetail.start}`)
                .tz(systemTz)
                .subtract(1, "hour");
              const endTime = moment(`${eventDetail.end}`).tz(systemTz);
              const currentTime = moment(eventDetail.current_time); //moment().utcOffset(eventDetail.tz);
              // console.log('meetingId', eventDetail.meetingId)
              if (currentTime.isBetween(startTime, endTime)) {
                return (
                  <>
                    {/* <button className={'btn-join active'}
                          onClick={() => hostSessionData(eventDetail)}>
                            Host
                          </button> */}
                    <RenderButtonForCalendar
                      isActive={true}
                      title="Host"
                      isLoaded={showLoaderLive}
                      eventData={eventDetail}
                      onClick={(eventDetail) =>
                        eventDetail.is_boardcast
                          ? showBoardcastLive(eventDetail)
                          : hostSessionData(eventDetail)
                      }
                      isLiveButton={true}
                    />
                  </>
                );
              }
            }
          } else {
            if (eventDetail.tense === "past") {
              return <>{/* Session has ended. */}</>;
            } else {
              if (eventDetail.selling_price === 0) {
                if (userRole === "host" || userRole === "instructor") {
                  const systemTz =
                    Intl.DateTimeFormat().resolvedOptions().timeZone;
                  const startTime = moment(`${eventDetail.start}`)
                    .tz(systemTz)
                    .subtract(1, "hour");
                  const endTime = moment(`${eventDetail.end}`).tz(systemTz);
                  const currentTime = moment(eventDetail.current_time); //moment().utcOffset(eventDetail.tz);
                  if (currentTime.isBetween(startTime, endTime)) {
                    return (
                      <RenderButtonForCalendar
                        isActive={true}
                        title="Join"
                        isLoaded={showLoaderLive}
                        eventData={eventDetail}
                        onClick={(eventDetail) =>
                          eventDetail.is_boardcast
                            ? showBoardcastLive(eventDetail)
                            : launchSessionLive(eventDetail)
                        }
                        isLiveButton={true}
                      />
                    );
                  } else {
                    return (
                      <RenderButtonForCalendar
                        isActive={false}
                        title="Join"
                        isLoaded={showLoaderLive}
                        eventData={eventDetail}
                        onClick={(eventDetail) => {}}
                        isLiveButton={true}
                      />
                    );
                  }
                } else {
                  if (eventDetail.showRegister || eventDetail.beforeEndTime) {
                    return (
                      <>
                        <RenderButtonForCalendar
                          isActive={true}
                          title="Register"
                          isLoaded={showLoaderLive}
                          eventData={eventDetail}
                          onClick={(eventDetail) =>
                            proceedToRegisterLive(eventDetail)
                          }
                          isLiveButton={true}
                        />
                      </>
                    );
                  } else {
                    return <></>;
                  }
                }
              } else {
                return (
                  <>
                    {eventDetail.showRegister || eventDetail.cross30 ? (
                      <RenderButtonForCalendar
                        isActive={true}
                        title={
                          eventDetail.is_addToCart ? "Added in Cart" : "Book"
                        }
                        isLoaded={showLoaderLive}
                        eventData={eventDetail}
                        onClick={(eventDetail) =>
                          proceedToBookLive(eventDetail)
                        }
                        isLiveButton={true}
                      />
                    ) : (
                      ""
                    )}
                  </>
                );
              }
            }
            // console.log('EVENT CLICKED NOT PAID', eventDetail.title)
          }
        }
      }
    }
  };

  return <>{renderButton(eventData)}</>;
};

export default LiveMenuButton;
